"use client";

import { signOut } from 'next-auth/react'
import type { Session } from 'next-auth'

/**
 * Check if the session has a refresh error and handle it appropriately
 * @param session - The NextAuth session object
 * @returns true if the session has an error that requires re-authentication
 */
export function hasSessionError(session: Session | null): boolean {
  return session?.error === 'RefreshAccessTokenError'
}

/**
 * Handle session errors by signing out the user and redirecting to login
 * @param session - The NextAuth session object
 * @param redirectUrl - Optional URL to redirect to after sign out
 */
export async function handleSessionError(
  session: Session | null,
  redirectUrl?: string
): Promise<void> {
  if (hasSessionError(session)) {
    // Sign out and redirect to login page
    await signOut({ 
      callbackUrl: redirectUrl || '/login',
      redirect: true 
    })
  }
}